export const footballBg = [
    {
        name: "Football Half (Pro)",
        image: `/default-images/backgrounds/football-pro-half.jpg`,
    },
    {
        name: "Football Half (College)",
        image: `/default-images/backgrounds/football-college-half.jpg`,
    },
    /* {
        name: "Football Half (College Num)",
        image: `/default-images/backgrounds/football-college-half-num.jpg`,
    }, */
    {
        name: "Football (Pro)",
        image: `/default-images/backgrounds/football-pro.jpg`,
    },
    {
        name: "Football (College)",
        image: `/default-images/backgrounds/football-college.jpg`,
    },
    {
        name: "Football College-Goal",
        image: `/default-images/backgrounds/football-college-goal.jpg`,
    },
    {
        name: "Football Pro-Goal",
        image: `/default-images/backgrounds/football-pro-goal.jpg`,
    },
    /* {
            name: "College Football Half",
            image: `/default-images/backgrounds/college-football-half.jpg`,
        },
    {
        name: "College Football Half EZ",
        image: `/default-images/backgrounds/college-football-half-ez.jpg`,
    },
    {
        name: "Pro Football Half EZ",
        image: `/default-images/backgrounds/pro-football-half-ez.jpg`,
    },*/
];

export const basketballBg = [
    {
        name: "Basketball",
        image: "/default-images/backgrounds/basketball.jpg",
    },
    {
        name: "Basketball Half",
        image: "/default-images/backgrounds/basketball-half.jpg",
    },
    {
        name: "College Basketball Full",
        image: "/default-images/backgrounds/Basketball-Full-College.jpg",
    },
    {
        name: "High School Basketball Full",
        image: "/default-images/backgrounds/Basketball-Full-HS.jpg",
    },
    {
        name: "International Basketball Full",
        image: "/default-images/backgrounds/Basketball-Full-Int.jpg",
    },
    {
        name: "College Basketball Half",
        image: "/default-images/backgrounds/Basketball-Half-College.jpg",
    },
    {
        name: "High School Basketball Half",
        image: "/default-images/backgrounds/Basketball-Half-HS.jpg",
    },
    {
        name: "International Basketball Half",
        image: "/default-images/backgrounds/Basketball-Half-Int.jpg",
    },
    {
        name: "College Basketball Full (Parkay)",
        image: "/default-images/backgrounds/Basketball-Full-College1.jpg",
    },
    {
        name: "High School Basketball Full (Parkay)",
        image: "/default-images/backgrounds/Basketball-Full-HS1.jpg",
    },
    {
        name: "International Basketball Full (Parkay)",
        image: "/default-images/backgrounds/Basketball-Full-Int1.jpg",
    },
    {
        name: "College Basketball Half (Parkay)",
        image: "/default-images/backgrounds/Basketball-Half-College1.jpg",
    },
    {
        name: "High School Basketball Half (Parkay)",
        image: "/default-images/backgrounds/Basketball-Half-HS1.jpg",
    },
    {
        name: "International Basketball Half (Parkay)",
        image: "/default-images/backgrounds/Basketball-Half-Int1.jpg",
    },
    {
        name: "College Basketball Full (Green)",
        image: "/default-images/backgrounds/Basketball-Full-College2.jpg",
    },
    {
        name: "High School Basketball Full (Green)",
        image: "/default-images/backgrounds/Basketball-Full-HS2.jpg",
    },
    {
        name: "International Basketball Full (Green)",
        image: "/default-images/backgrounds/Basketball-Full-Int2.jpg",
    },
    {
        name: "College Basketball Half (Green)",
        image: "/default-images/backgrounds/Basketball-Half-College2.jpg",
    },
    {
        name: "High School Basketball Half (Green)",
        image: "/default-images/backgrounds/Basketball-Half-HS2.jpg",
    },
    {
        name: "International Basketball Half (Green)",
        image: "/default-images/backgrounds/Basketball-Half-Int2.jpg",
    },
    {
        name: "College Basketball Full (Blue)",
        image: "/default-images/backgrounds/Basketball-Full-College3.jpg",
    },
    {
        name: "High School Basketball Full (Blue)",
        image: "/default-images/backgrounds/Basketball-Full-HS3.jpg",
    },
    {
        name: "International Basketball Full (Blue)",
        image: "/default-images/backgrounds/Basketball-Full-Int3.jpg",
    },
    {
        name: "College Basketball Half (Blue)",
        image: "/default-images/backgrounds/Basketball-Half-College3.jpg",
    },
    {
        name: "High School Basketball Half (Blue)",
        image: "/default-images/backgrounds/Basketball-Half-HS3.jpg",
    },
    {
        name: "International Basketball Half (Blue)",
        image: "/default-images/backgrounds/Basketball-Half-Int3.jpg",
    },
];

export const soccerBg = [
    {
        name: "Soccer",
        image: `/default-images/backgrounds/soccer.jpg`,
    },
    {
        name: "Soccer Half",
        image: `/default-images/backgrounds/soccer-half.jpg`,
    },
];

export const hockeyBg = [
    {
        name: "Hockey",
        image: `/default-images/backgrounds/hockey.jpg`,
    },
    {
        name: "Hockey Half",
        image: `/default-images/backgrounds/hockey-half.jpg`,
    },
];

export const fieldHockeyBg = [
    {
        name: "Field Hockey Full",
        image: `/default-images/backgrounds/field-hockey-full.jpg`,
    },
    {
        name: "Field Hockey Half",
        image: `/default-images/backgrounds/field-hockey-half.jpg`,
    },
];

export const lacrosseBg = [
    {
        name: "Lacrosse Full",
        image: `/default-images/backgrounds/lacrosse-full.jpg`,
    },
    {
        name: "Lacrosse Half",
        image: `/default-images/backgrounds/lacrosse-half.jpg`,
    },
];

export const volleyballBg = [
    {
        name: "Volley Ball Full",
        image: `/default-images/backgrounds/volley-ball-full.jpg`,
    },
    {
        name: "Volley Ball Half",
        image: `/default-images/backgrounds/volley-ball-half.jpg`,
    },
];
